export default function withCurrency(title: string, currency: string): string {
  if (currency) return `${title} (${currency})`;
  return title;
}
